import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  buttonName,
  commonValidationMsg,
  createPricingPlan,
  fieldValidation,
  invoiceTab,
  updateStatusModalData
} from "../../locales/en";
import { useParams } from "react-router-dom";
import { getCustomerInvoiceStatusApprovalData } from "../../redux/invoiceDetailsSlice";
import { useDispatch } from "react-redux";
import Style from "./modal.module.scss";
import { showToast } from "../../utils/utils";
import { showToastType } from "../../utils/constants/appConstants";
import { STATUS_2 } from "../../utils/constants/appConstants";
import CommonModal from "./CommonModal";
import "./../../assets/scss/common.scss";

const CustomerStatusUpdateApprovalInfo = ({
  isOpen,
  toggle,
  approvalData,
  handleGroupStatusUpdate
}) => {
  const { id } = useParams();
  const dispatch = useDispatch();

  const initialFormData = {
    comment: ""
  };

  const [formData, setFormData] = React.useState(initialFormData);
  const [errorMessage, setErrorMessage] = useState({});

  const handleUpdateApprovalStatus = async () => {
    if (!formData.comment.trim()) {
      setErrorMessage({ comment: fieldValidation?.required });
      return;
    }
    try {
      const payload = {
        quoteIds: [Number(id)],
        reason: formData.comment
      };
      const response = await dispatch(
        getCustomerInvoiceStatusApprovalData(payload)
      ).unwrap();
      if (response.status === 200) {
        toggle(false);
        showToast(response.data.message, showToastType.success);
        handleGroupStatusUpdate(STATUS_2);
        setErrorMessage({});
      }
    } catch {
      // handle error here
    }
  };
  return (
    <CommonModal
      isOpen={isOpen}
      toggle={toggle}
      title={invoiceTab?.customerInvTable?.errMsg?.item3}
      bodyClassName="p-3"
      footerButtons={[
        {
          label: buttonName.close,
          className: "btn btn-secondary",
          onClick: () => toggle(false)
        },
        {
          label: createPricingPlan?.propertyOptions?.item1,
          className: "btn btn-primary",
          onClick: handleUpdateApprovalStatus
        }
      ]}
    >
      <div className="row">
        {approvalData && (
          <div className="mb-3">
            <div className={Style.modalInputwrap}>
              <p>
                {updateStatusModalData?.sub3} {approvalData?.customer}
                {` to `}
                {approvalData?.requestedAmount}
              </p>
              <p>
                {approvalData?.warning} {approvalData?.availableCredit}
              </p>
            </div>
          </div>
        )}
        <div className="mb-3">
          <div className={Style.modalInputwrap}>
            <label htmlFor="comments" className="mb-1">
              {commonValidationMsg?.wishProced}
            </label>
            <div className={Style.formInput}>
              <textarea
                id="comments"
                name="comment"
                value={formData.comment}
                onChange={(e) => {
                  setFormData({ ...formData, comment: e.target.value });
                  setErrorMessage({});
                }}
                className="form-control height-150"
                rows="6"
                placeholder={updateStatusModalData?.placeholder}
              />
              {errorMessage.comment && (
                <div className="text-danger small">{errorMessage.comment}</div>
              )}
            </div>
          </div>
        </div>
      </div>
    </CommonModal>
  );
};
CustomerStatusUpdateApprovalInfo.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  approvalData: PropTypes.object,
  handleGroupStatusUpdate: PropTypes.func.isRequired
};

export default CustomerStatusUpdateApprovalInfo;
